'use client'

import { Home } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
// Example:
// <Breadcrumb
//         items={[
//           { name: 'Danh mục cấp 0', href: '/danh-muc-0' },
//           { name: 'Danh mục cấp 1', href: '/danh-muc-0/cap-1' },
//           { name: 'Category name' },
//         ]}
//       />

interface BreadcrumbItem {
  title: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const t = useTranslations('title')
  const lastIndex = items.length - 1

  return (
    <nav
      className='scrollbar-hide overflow-x-auto'
      aria-label='breadcrumb'
      itemScope
      itemType='https://schema.org/BreadcrumbList'
    >
      <ol className='flex min-w-0 items-center space-x-1 whitespace-nowrap text-sm text-neutral-400'>
        <li
          className='flex flex-shrink-0 items-center'
          itemProp='itemListElement'
          itemScope
          itemType='https://schema.org/ListItem'
        >
          <Link
            href='/'
            className='flex items-center gap-1 text-neutral-400'
            itemProp='item'
          >
            <Home size={14} />
            <span itemProp='name' className='sr-only'>
              {t('home')}
            </span>
          </Link>
          <meta itemProp='position' content='1' />
        </li>

        {items.map((item, index) => (
          <li
            key={index}
            className='flex flex-shrink-0 items-center py-0.5'
            itemProp='itemListElement'
            itemScope
            itemType='https://schema.org/ListItem'
          >
            <span className='mx-1'>/</span>
            {index === lastIndex ? (
              <span
                className='text-sm leading-4 text-neutral-700'
                itemProp='name'
              >
                {item.title}
              </span>
            ) : (
              <Link
                href={item.href ?? ''}
                className='text-sm leading-4 text-neutral-400 hover:underline'
                itemProp='item'
              >
                <span itemProp='name'>{item.title}</span>
              </Link>
            )}
            <meta itemProp='position' content={(index + 2).toString()} />
          </li>
        ))}
      </ol>
    </nav>
  )
}
